import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const StreamingCursor = () => (
  <span
    className="streaming-cursor"
    aria-hidden="true"
    style={{
      display: 'inline-block',
      width: '2px',
      height: '1em',
      background: 'currentColor',
      marginLeft: '2px',
      verticalAlign: 'text-bottom',
      animation: 'blink-cursor 0.8s step-end infinite',
    }}
  />
);

const AISuggestionPanel = ({ aiData, aiError, isPredefined, predefinedLabel, onClose }) => {
  if (!aiData && !aiError) return null;

  const isStreaming = aiData?.streaming === true;
  const hasAiSuggestion = aiData && 'ai_suggestion' in aiData;
  const hasFallback = aiData && 'quick_tips' in aiData;
  const hasActionPlan = aiData && ('actions_md' in aiData || 'actions' in aiData);

  const resolvedLabel = predefinedLabel || 'Recomendaciones';
  const panelTitle = isPredefined ? resolvedLabel : 'Sugerencias de IA';
  const panelIcon = isPredefined ? '📋' : '🤖';
  const sectionTitle = isPredefined ? resolvedLabel : 'Analisis y recomendaciones';

  return (
    <>
      <style>{`
        @keyframes blink-cursor {
          0%, 100% { opacity: 1; }
          50%       { opacity: 0; }
        }
      `}</style>

      <div
        className="ai-drawer-overlay"
        onClick={onClose}
        aria-hidden="true"
      />

      <aside className="ai-drawer" aria-label={panelTitle}>
        <div className="ai-drawer-header">
          <div className="ai-drawer-title">
            <span className="ai-drawer-icon">{panelIcon}</span>
            <h2>
              {panelTitle}
              {isStreaming && !isPredefined && (
                <span
                  className="streaming-badge"
                  aria-live="polite"
                  style={{
                    marginLeft: 8,
                    fontSize: '0.7rem',
                    fontWeight: 400,
                    letterSpacing: '0.05em',
                    padding: '2px 8px',
                    borderRadius: 999,
                    background: 'var(--color-primary, #4f46e5)',
                    color: '#fff',
                    verticalAlign: 'middle',
                  }}
                >
                  Generando...
                </span>
              )}
            </h2>
          </div>
          <button
            className="ai-drawer-close"
            onClick={onClose}
            aria-label="Cerrar panel de sugerencias"
            title="Cerrar"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div className="ai-drawer-body">
          {aiError && (
            <div className="error-text">{aiError}</div>
          )}

          {aiData && (
            <>
              {hasAiSuggestion && (
                <div className="ai-drawer-section">
                  <h3>{sectionTitle}</h3>
                  <div className="ai-content">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {aiData.ai_suggestion}
                    </ReactMarkdown>
                    {isStreaming && !isPredefined && <StreamingCursor />}
                  </div>
                </div>
              )}

              {hasFallback && (
                <div className="ai-drawer-section">
                  <h3>Tips rapidos</h3>
                  <ul>
                    {aiData.quick_tips.map((t, i) => (<li key={i}>{t}</li>))}
                  </ul>
                  {aiData.improvement_ideas?.length > 0 && (
                    <>
                      <h4>Ideas de mejora</h4>
                      <ul>
                        {aiData.improvement_ideas.map((t, i) => (<li key={i}>{t}</li>))}
                      </ul>
                    </>
                  )}
                </div>
              )}

              {'actions_md' in aiData && (
                <div className="ai-drawer-section">
                  <h3>Plan de accion</h3>
                  <div className="ai-content">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {aiData.actions_md}
                    </ReactMarkdown>
                  </div>
                </div>
              )}

              {'actions' in aiData && Array.isArray(aiData.actions) && (
                <div className="ai-drawer-section">
                  <h3>Acciones sugeridas</h3>
                  <ul>
                    {aiData.actions.map((a, i) => (<li key={i}>{a}</li>))}
                  </ul>
                </div>
              )}

              {!hasAiSuggestion && !hasFallback && !hasActionPlan && (
                <div className="ai-drawer-section">
                  <p>No se recibieron sugerencias del servidor.</p>
                </div>
              )}
            </>
          )}
        </div>
      </aside>
    </>
  );
};

export default AISuggestionPanel;
